__turbopack_context__.v({
  "alert": "GynPwq_alert",
  "alertnoCornerRadius": "GynPwq_alertnoCornerRadius",
  "alertstatus_darkInfo": "GynPwq_alertstatus_darkInfo",
  "alertstatus_error": "GynPwq_alertstatus_error",
  "alertstatus_warning": "GynPwq_alertstatus_warning",
  "icon": "GynPwq_icon",
  "iconWrapper": "GynPwq_iconWrapper",
  "iconstatus_darkInfo": "GynPwq_iconstatus_darkInfo",
  "iconstatus_error": "GynPwq_iconstatus_error",
  "iconstatus_warning": "GynPwq_iconstatus_warning",
  "noticeWrapper": "GynPwq_noticeWrapper",
  "noticeWrapperstretch": "GynPwq_noticeWrapperstretch",
  "text": "GynPwq_text",
  "textstatus_darkInfo": "GynPwq_textstatus_darkInfo",
  "textstatus_error": "GynPwq_textstatus_error",
  "textstatus_warning": "GynPwq_textstatus_warning",
});
